import { isTextFile } from './fileTypeHelpers';
import { generateTextThumbnail } from './textThumbnail';

/**
 * Generates a preview blob URL for a file (image or text).
 * Rejects if preview generation fails or file type is unsupported.
 *
 * @param fileObject - The file to generate a preview for
 * @returns Promise resolving to blob URL
 * @throws Error if file type is unsupported or generation fails
 */
export async function generateFilePreview(fileObject: File): Promise<string> {
	if (fileObject.type.startsWith('image/')) {
		try {
			return URL.createObjectURL(fileObject);
		} catch (error) {
			const errorMessage =
				error instanceof Error
					? error.message
					: typeof error === 'string'
						? error
						: 'Failed to create blob URL for image file';
			throw new Error(`Failed to create blob URL for image: ${errorMessage}`);
		}
	} else if (isTextFile(fileObject.type, fileObject.name)) {
		return await generateTextThumbnail(fileObject);
	}
	throw new Error(`Unsupported file type: ${fileObject.type}`);
}
